import axios from 'axios';

export const COCKPIT_CONTEXT_QUICK_CASHFLOW = 'quick_cashflow';
export const COCKPIT_CONTEXT_TEARSHEET_SUMMARY = 'tearsheet_summary';

export const cockpitAssistApi = async ({
  context,
  message,
  files,
  history,
  contextData,
  cohortColumnMapping,
  assistSession,
  cohortSheet,
  customerId,
  signal,
}) => {
  const formData = new FormData();
  formData.append('context', context);
  if (message) formData.append('message', message);
  if (customerId) formData.append('customerId', customerId);
  if (history?.length) formData.append('history', JSON.stringify(history));
  if (contextData) formData.append('contextData', contextData);
  if (cohortColumnMapping) {
    formData.append('cohortColumnMapping', JSON.stringify(cohortColumnMapping));
  }
  if (assistSession) {
    formData.append('assistSession', JSON.stringify(assistSession));
  }
  if (cohortSheet?.cohorts?.length) {
    formData.append('cohortSheet', JSON.stringify(cohortSheet));
  }
  (files || []).forEach((file) => {
    formData.append('files', file);
  });
  const response = await axios.post('admin/cockpit/assist', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
    signal,
  });
  return response.data;
};

export const quickCashflowAssistApi = async ({
  message,
  files,
  history,
  cohortColumnMapping,
  assistSession,
}) => {
  const data = await cockpitAssistApi({
    context: COCKPIT_CONTEXT_QUICK_CASHFLOW,
    message,
    files,
    history,
    cohortColumnMapping,
    assistSession,
  });
  return data?.quickCashflow || data;
};

export const tearsheetAssistApi = async ({
  message,
  history,
  contextData,
}) => {
  const data = await cockpitAssistApi({
    context: COCKPIT_CONTEXT_TEARSHEET_SUMMARY,
    message,
    history,
    contextData,
  });
  return data?.tearsheet || data;
};
